
export default [
  {
    path: '/admin/coa-categories',
    name: 'coa-category',
    meta: { requiresAuth: true },
    component: () => import('@/pages/accounting/coa-category')
  }
]
